export const STORAGE_KEYS = {
    ACCESS_TOKEN: 'frontAccessToken',
    REFRESH_TOKEN: 'frontRefreshToken',
} as const;

export const SLICE_NAMES = {
    AUTH: 'auth',
    MAIN_LAYOUT: 'mainLayout',
    WIDGETS: 'widgets',
    USER_AVATAR: 'userAvatar',
    APP_DATA: 'appData',
    DICTIONARY: 'dictionary',
    DOCUMENT: 'document',
    NOTIFICATION_SETTINGS: 'notificationSettings',
    REPORT: 'report',
    ROLES: 'roles',
    SEARCH: 'search',
} as const;

/**
 * Максимальный размер загружаемого файла в kB
 */
export const MAX_FILE_SIZE: number | undefined = 300 * 1024;
